import { IInactivityTimerProps } from 'components/domain/timer/useInactivityTimer';
import { useHelpOverlayInactivityTimer } from './useHelpOverlayInactivityTimer';

export const FdrHelpOverlayInactivityTimer: React.FC<IInactivityTimerProps> =
  props => {
    useHelpOverlayInactivityTimer(props);
    return null;
  };
